import React from 'react'
import { Check2 } from 'react-bootstrap-icons'
import Button from '../atoms/Button/ButtonV2'

type FeatureProps = {
  title: string
}

const Feature: React.FC<FeatureProps> = ({ title }) => (
  <div className="flex gap-4">
    <div className="flex size-6 items-center justify-center rounded-full bg-primary-50">
      <Check2 className="size-4 text-gray-1100" />
    </div>
    <span className="font-medium text-gray-1100">{title}</span>
  </div>
)

const ForTreatmentProviders: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-10 xl:flex-row xl:gap-0">
      <div className="relative order-2 w-full xl:order-1 xl:min-w-[685px]">
        <img
          className="aspect-[3/2] w-full rounded-2xl object-cover  xl:max-w-[685px]"
          src="https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_60,f_auto,w_900,ar_3:2/v1712587432/recovery/2b8100211d7e590e1db1e79f797ba796.jpg"
          alt="About Recovery.com Team Photo"
        />
        <div className="absolute left-4 top-4 rounded bg-white/80 px-2 py-0.5 text-xs backdrop-blur-[1px]">
          Recovery.com Team in Madison, WI
        </div>
      </div>

      <div className="order-1 flex w-full flex-col gap-8 xl:order-2 xl:px-16">
        <div className="flex flex-col items-start justify-center gap-6">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-semibold uppercase tracking-[1px] text-primary-400">
              For Treatment Providers
            </p>
            <p className="font-FieldsVariable text-2xl font-medium text-gray-1100 xl:max-w-[296px]">
              It's Free to Be on Recovery.com
            </p>
          </div>
          <p className="text-lg text-gray-700">
            We offer a free, comprehensive service for behavioral healthcare
            providers, complimented by premium advertising designed to
            accelerate patient acquisition and practice growth.
          </p>
          <div className="flex flex-col gap-4 md:hidden xl:flex ">
            <Feature title="Patient Centered" />
            <Feature title="Ethical Advertising " />
          </div>
        </div>
        <div>
          <Button
            type="secondary"
            as="a"
            href="https://providers.recovery.com/"
            className="inline-block w-full md:w-auto"
          >
            Explore Marketing Solutions
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ForTreatmentProviders
